module.exports = "https://www.gc-qa.gnp.com.mx/f9679ef2d38afe6283d4069619dcc874.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/folder_black_24dp.svg
// module id = 1821
// module chunks = 0